import React, { Component } from 'react'
import Styles from './WorkflowDialogBox.module.css'
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker-overrides.css';
import options from './options.json';
import _DatePickerModule from 'react-datepicker';
const DatePicker = _DatePickerModule.default || _DatePickerModule;

class WorkflowDialogField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            required: this.props.required,
            checked: false,
            uploadFiles: [],
            uploadFileNames: [],
            fileDisplay:[]
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleGroupFiles = this.handleGroupFiles.bind(this);
        this.handleMultipleGroupFiles = this.handleMultipleGroupFiles.bind(this);
        this.handleFiles = this.handleFiles.bind(this);
        this.isValid = this.isValid.bind(this);
        this.computeCSSClass = this.computeCSSClass.bind(this);
    }
    componentDidMount() {
        switch (this.props.field.DataType) {
            case "fileuploadgroup":
                this.updateFileDisplay(this.props.fileArr);
                break;
            case "fileupload":
                this.setState({ value: this.props.value })
                break;
            case "bool":
                var boolValue = (!this.props.value || this.props.value == 'false') 
                    ? false 
                    : true;
                this.setState({ checked: boolValue  })
                break;
            case "datetime":
                var dtvalue = null;
                if (this.props.value && this.props.value != undefined && this.props.value != '') {
                    dtvalue = new Date(this.props.value)
                }
                this.setState({ value: dtvalue  })
                break;
            default:
                this.setState({ value: this.props.value  })
                break;
        }
    }
    isValid(value) {
        if (this.state.required && (value == undefined || value == null || value == '' || value == "")) {
            return (false);
        } else {
            return(true)
        }
    }
    computeCSSClass(value) {
        if (this.props.disabled) {
            //all controls are disabled here
            return [Styles.wfinput]
        } else {
            if (this.isValid(value)) {
                return [Styles.wfinput]
            } else {
                return [Styles.wfinput, Styles.Wiggle].join(" ")
            }
        }
    }
    handleChange(event) {
        this.setState({
            value: event.target.value
        })
        
        this.props.setValue(event.target, this.props.field.ActionName, this.props.field.IsDisabled);
    }
    handleCheckChange(event) {
        var CheckBoxValue = event.target.checked ? true : false;
        this.setState({ checked: CheckBoxValue })
        this.props.setCheckValue(event.target, this.props.field.ActionName, CheckBoxValue);
    }
    updateFileDisplay(fileArr) {
        var fileDisplay = [];

        fileArr.forEach((element) => {
           
            fileDisplay.push(<div className={Styles.filerow}> <div className={Styles.fileleft}>{element.title} </div> <div className={Styles.fileright}>{element.name}</div><br /></div>);
        

        });
        this.setState({ fileDisplay: fileDisplay });
    }
    handleFiles(event) {
        var fn = event.currentTarget.files[0].name;

        var newName = this.props.pn + "_" + event.currentTarget.name.replace("wfdata_", "") + "." + fn.substring(fn.lastIndexOf('.') + 1, fn.length);
        this.props.setUploadFile(event.currentTarget.files[0], newName);

    

    }
    handleGroupFiles(event) {
       

        var fn = event.currentTarget.files[0].name;
        var newName = this.props.pn + "_" + event.currentTarget.name.replace("wfdata_", "") + "." + fn.substring(fn.lastIndexOf('.') + 1, fn.length);

        var fileArr = this.props.setUploadFile([{
            title: event.currentTarget.name.replace("wfdata_", ""),
            file: event.currentTarget.files[0],
            filename: newName
        }]);

        this.updateFileDisplay(fileArr);

    }
    
    handleMultipleGroupFiles(event) {
        let fileInfoList = []
        for (let fileIndex = 0; fileIndex < event.currentTarget.files.length; fileIndex++) {
            let file = event.currentTarget.files[fileIndex]
            var newName = this.props.pn + "_Other_" + file.name;
            fileInfoList.push({
                title: event.currentTarget.name.replace("wfdata_", ""),
                file: file,
                filename: newName
            })
        }
        var fileArr = this.props.setUploadFile(fileInfoList);
        this.updateFileDisplay(fileArr); 
    }
    getOptions() {

        let optionsarr = [];
        var jsonArray = [];
        var list = options.options;
        var matchName = this.props.field.SelectOptions;

        for (let i = 0; i < list.length; i++) {
            var optionName = list[i].name;
            if (optionName == matchName) {
                jsonArray = list[i].data;
                for (let j = 0; j < jsonArray.length; j++) {
                    optionsarr.push(<option value={jsonArray[j].shortname} >{jsonArray[j].shortname}</option>);
                }
            }
        }

        return optionsarr;
    }
    getFieldDiv() {

        var returnField = (<div></div>);


        //Tooltip
        var hideToolTip = true;
        if (this.props.field.ToolTip != null && this.props.field.ToolTip != undefined && this.props.field.ToolTip != '') {
            hideToolTip = false;
        }

        let cssClass = this.computeCSSClass(this.state.value)

        switch (this.props.field.DataType) {

            case "text":
                returnField = (
                    <div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}>
                        <input type='text' name={this.props.field.FieldName} id={this.props.field.FieldName} disabled={this.props.disabled} className={cssClass} value={this.state.value}
                            onChange={this.handleChange} />
                        <div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div>
                    </div>);
                break;
            case "fileupload":
                returnField = (<div><div>
                    <input type='file' name={this.props.field.FieldName} id={this.props.field.FieldName} className={[Styles.wfinput, cssClass].join(" ")} value={this.props.value} onChange={this.handleFiles} />
                </div></div >);
                break;
            case "seperator":
                returnField = (<div>&nbsp;</div >);
                break;
            case "filelist":
                returnField = (<div ><div className={Styles.fileList} >
                    {this.state.uploadFiles}
                </div></div>);
                break;
            case "fileuploadgroup":
                returnField = (<div >
                   
                    <div >
                        <div className={Styles.fileHeader}>W9</div>
                        <input type='file' name={"W9"} id={"W9"} className={[Styles.wfinput, cssClass].join(" ")} onChange={this.handleGroupFiles} />
                    </div >

                    <div className={Styles.stretch}><div className={Styles.fileHeader}>Completed Application</div><input type='file' name={"Application"} id={"Application"} className={[Styles.wfinput].join(" ")} onChange={this.handleGroupFiles} /></div >

                    <div className={Styles.stretch}><div className={Styles.fileHeader}>Agenda</div><input type='file' name={"Agenda"} id={"Agenda"} className={[Styles.wfinput, cssClass].join(" ")} onChange={this.handleGroupFiles} /></div >
                    <div className={Styles.stretch}> <div className={Styles.fileHeader}>Prospectus</div><input type='file' name={"Prospectus"} id={"Prospectus"} className={[Styles.wfinput, cssClass].join(" ")} onChange={this.handleGroupFiles} /></div >
                    <div className={Styles.stretch}><div className={Styles.fileHeader}>Request Letter</div> <input type='file' name={"Request"} id={"Request"} className={[Styles.wfinput, cssClass].join(" ")} onChange={this.handleGroupFiles} /></div >
                    <div><div className={Styles.fileHeader}>Other Files</div><input type='file' multiple name={"Other"} id={"Other"} className={[Styles.wfinput, cssClass].join(" ")} onChange={this.handleMultipleGroupFiles} /></div >

                    <div>&nbsp;</div >

                    
                    <div className={Styles.fileList} >
                        {this.state.fileDisplay}

                    </div>
                </div >);
                break;
            case "currency":
                returnField = (<div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}><input name={this.props.field.FieldName}
                    id={this.props.field.FieldName} type='number' className={cssClass} value={this.state.value} onChange={this.handleChange} /><div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div></div>);
                break;
            case "phone":
                returnField = (<div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}><input name={this.props.field.FieldName}
                    id={this.props.field.FieldName} type='text' placeholder={"(xxx) xxx-xxxx"} className={cssClass} value={this.state.value} onChange={this.handleChange} /><div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div></div>);
                break;
            case "datetime":

                returnField = (
                    <DatePicker className={Styles.reactdatetime} selected={this.state.value} onChange={(event) => {

                        // var dt = new Date(event);
                        // alert(dt.getDate());

                        this.props.setDateValue(this.props.field.FieldName, event)
                        this.setState({ value: event })

                    }}  minDate={new Date()} />);

                break;
            case "search":
                returnField = (<div className={Styles.tooltip}><input name={this.props.field.FieldName} id={this.props.field.FieldName} type='text' className={cssClass} value={this.state.value} /> <span aria-hidden="true">🔍</span><div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div></div>);
                break;
            case "select":
                returnField = (<div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}><select name={this.props.field.FieldName} id={this.props.field.FieldName} className={cssClass} value={this.state.value}
                    onChange={this.handleChange} >
                    <option value='' ></option>
                    {this.getOptions()}
                </select> <div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div></div>
                );
                break;
            case "bool":
                returnField = (<div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}>
                    <input name={this.props.field.FieldName} id={this.props.field.FieldName} type='checkbox' checked={this.state.checked ? true : undefined} onChange={this.handleCheckChange} />
                    <div className={Styles.tooltiptext}>{this.props.field.ToolTip} </div></div>);
                break;
            case "textarea":
                returnField = (<div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}><div></div><textarea name={this.props.field.FieldName} id={this.props.field.FieldName}
                    className={cssClass} onChange={this.handleChange} >{this.props.value}</textarea><div className={hideToolTip ? Styles.tooltiphidden : Styles.tooltip}> </div></div>);
                break;
            default:
                break;
        }

        return returnField;

    }

    render() {
        return (
            <div className={Styles.formdiv}>
                {this.props.field.DataType == 'fileuploadgroup' ? '' : <div className={Styles.formtitle}>{this.props.field.FieldTitle}</div>}
                <div className={this.props.field.DataType == 'fileuploadgroup' ? Styles.filescontrol :Styles.formcontrol}>{this.getFieldDiv()}</div>
            </div>
        )
    }

}
export default WorkflowDialogField;